import { useState, useEffect } from 'react';
import { fetchBitcoinPrice, formatPriceChange } from '../services/bitcoinService';

const BitcoinPrice = () => {
  const [price, setPrice] = useState<number | null>(null);
  const [priceChangePercentage, setPriceChangePercentage] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        setIsLoading(true);
        const data = await fetchBitcoinPrice();
        setPrice(data.currentPrice);
        setPriceChangePercentage(data.priceChangePercentage24h);
      } catch (error) {
        console.error('Error fetching Bitcoin price:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPrice();

    // Refresh price every 5 minutes
    const interval = setInterval(fetchPrice, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // Determine price trend for styling
  const getPriceTrendClass = (): string => {
    if (priceChangePercentage > 0) return 'text-green-500';
    if (priceChangePercentage < 0) return 'text-red-500';
    return 'text-[#A3A3A3]';
  };

  // Return compact display
  return (
    <div className="flex items-center gap-1 text-xs">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="text-[#F7931A]" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8.83 10.94C8.6445 8.744 10.1535 7.832 12.05 7.44L12.05 5.5H13.45L13.45 7.4C13.856 7.4 14.272 7.426 14.69 7.454L14.69 8.83C14.352 8.798 13.994 8.776 13.64 8.776C13.176 8.776 12.735 8.808 12.328 8.844L12.328 12.03C14.642 12.422 16.35 13.034 16.35 15.033C16.35 17.054 14.75 18.084 12.7 18.336L12.7 20.5H11.3L11.3 18.35C10.792 18.35 10.27 18.322 9.75 18.28L9.75 16.88C10.118 16.916 10.54 16.934 10.96 16.934C11.614 16.934 12.17 16.898 12.644 16.844L12.644 13.39C10.384 13.008 8.83 12.318 8.83 10.94ZM12.41 8.956C11.428 9.124 10.78 9.598 10.892 10.838C10.95 11.346 11.382 11.7 12.41 11.976L12.41 8.956ZM13.164 16.77C14.236 16.626 14.9 16.034 14.84 14.998C14.786 14.106 14.222 13.674 13.164 13.408L13.164 16.77Z"/>
      </svg>

      {isLoading ? (
        <div className="animate-pulse h-4 bg-[#2A2633] rounded w-16"></div>
      ) : (
        <>
          <span className="text-white font-medium">
            ${price?.toLocaleString()}
          </span>
          <span className={`${getPriceTrendClass()} ml-1`}>
            {formatPriceChange(priceChangePercentage, true)}
          </span>
        </>
      )}
    </div>
  );
};

export default BitcoinPrice;
